import { fluids } from '~lib/common/config/fluids';
import medicationLabel from '~lib/common/utils/medicationLabel';

export function initialMedicationLabel(initialMedication, medicationsById, caseConf) {
  if (initialMedication.treatmentType === 'MEDICATION') {
    const medication = medicationsById[initialMedication.medOrFluidId];
    if (!medication) {
      return 'N/A';
    }
    const dosageForm = caseConf.dosageForms.find(
      df => df.medicationId === medication.id,
    );
    let dosageFormType;
    let concentration
    if (dosageForm) {
      dosageFormType = dosageForm.dosageFormType;
      concentration = dosageForm.concentration;
    } else {
      dosageFormType = medication.dosageForm;
      concentration = medication.defaultConcentration;
    }
    const customGroups = caseConf.customMedGroups || [];
    return medicationLabel(
      dosageFormType,
      medication.group,
      concentration,
      { includeGroup: true, customGroups },
    );
  } else if (initialMedication.treatmentType === 'FLUID') {
    const allFluids = fluids.concat(caseConf.customFluids || []);    
    const fluid = allFluids.find(fluid => fluid.key === initialMedication.medOrFluidId);
    if (!fluid) {
      return 'N/A';
    }
    return fluid.label.en;
  }

  return initialMedication.id;
}
